<template lang="html">

  <section class="footer">

    <div class="top">

      <div class="container row-center ais">
        <article class="column logo">
          <img class="img-logo" src="/static/img/risi-gray-logo.png" width="107" alt="Logo risi">
          <div class="rrss">
            <h3>{{$t('header.siguenos')}}</h3>
            <nav class="links row-center">
              <a href="https://www.instagram.com/risioriginal/?hl=es" target="_blank"><i class="fa fa-instagram"></i></a>
              <a href="https://www.tiktok.com/@risioriginal?lang=es" target="_blank"><img src="/static/img/icon-tiktok.svg"></a>
              <a href="https://twitter.com/risioficial?lang=es" target="_blank"><img src="/static/img/icon-twitter-new.svg"></a>
            </nav>
          </div>
        </article>
        <article class="column">
          <router-link class="title" to="">{{$t('vistas.productos')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.snacks')">{{$t('vistas.snacks')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.galletas')">{{$t('vistas.galletas')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.caramelos')">{{$t('vistas.caramelos')}}</router-link>
          <a @click="sendevent('tareas-gusanitos')" :href="'/'+$i18n.locale+'/'+$t('enlaces.borges')">{{$t('header.frutosSecos')}}</a>
          <a @click="sendevent('tareas-gusanitos')" :href="'/'+$i18n.locale+'/'+$t('enlaces.patatas')">{{$t('header.patatas')}}</a>
          <!-- <router-link :to="$t('enlaces.promociones')">{{$t('vistas.promociones')}}</router-link> -->
        </article>
        <article class="column">
          <router-link class="title" to="">{{$t('vistas.sobre_risi')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.quienessomos')">{{$t('vistas.quienessomos')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.historia')">{{$t('vistas.historia')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.noticias')">{{$t('vistas.noticias_risi')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.nutririsi')">{{$t('vistas.nutririsi')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.faqs')">{{$t('vistas.faqs')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.contacto')">{{$t('vistas.contacto')}}</router-link>
        </article>
        <article class="column">
              <router-link class="title" to="">{{ $t('vistas.profesionales') }}</router-link>
              <router-link :to="'/' + $i18n.locale + '/' + $t('enlaces.distribuidores')">{{ $t('vistas.distribuidores') }}</router-link>
              <router-link :to="'/' + $i18n.locale + '/' + $t('enlaces.pressroom')">{{ $t('vistas.press_room') }}</router-link>
              <router-link :to="'/' + $i18n.locale + '/' + $t('enlaces.materialesprensa')">{{ $t('vistas.materialesprensa') }}</router-link>
        </article>
        <article class="column">
          <router-link class="title" to="">{{$t('vistas.legal')}}</router-link>   
          <router-link :to="'/' + $i18n.locale + '/' + $t('enlaces.regulatory_compliance')">{{ $t('vistas.regulatory_compliance') }}</router-link>   
          <router-link :to="'/' + $i18n.locale + '/' + $t('enlaces.ethical_channel')">{{ $t('vistas.ethical_channel') }}</router-link>   
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.politica_cookies')">{{$t('vistas.politica_cookies')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.aviso_legal')">{{$t('vistas.aviso_legal')}}</router-link>
          <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.politica_privacidad')">{{$t('vistas.proteccion_datos')}}</router-link>
          <router-link v-if="$i18n.locale === 'es'" :to="'/'+$i18n.locale+'/'+$t('enlaces.bases_legales_risi')">{{ $t('vistas.bases_legales_risi') }}</router-link>
        </article>
        <article class="column autocontrol">
          <img src="/static/img/logos/logo-distintivo.svg" width="250" alt="Logo Autocontrol">
        </article>
      </div>

      <div class="container row-center subvenciones">
        <article>
          <router-link :to="$t('enlaces.noticia') + '/risi-realiza-innovadoras-mejoras-en-sus-fabricas-de-produccion-y-envasado'">
            <img width="300" src="/static/img/logos/subvenciones-PATATA.jpg" alt="Subvención sobre 2 encartonadoras automáticas">
          </router-link>
        </article>
        <article>
          <router-link :to="$t('enlaces.noticia') + '/risi-realiza-innovadoras-mejoras-en-sus-fabricas-de-produccion-y-envasado'">
            <img width="300" src="/static/img/logos/subvenciones-SNACKS.jpg" alt="Subvención sobre equipo de dosificación de pequeños ingredientes">
          </router-link>
        </article>
      </div>
    </div>

    <div class="bottom">
      <div class="container">
        <p>{{ $t('infoFooter')}}</p>
      </div>
    </div>

  </section>

</template>

<script lang="js">

  import idioma from '@/components/view-parts/footer/idioma'

  export default {
    name: 'app-footer',
    components: {
      'idioma': idioma
    },
    methods: {
      sendevent(event) {
        this.$gtm.trackEvent({
          event: 'event',
          category: "Descarga documento",
          action: "click",
          label: event,
          value: event,
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/css/colors.scss';

  .footer {
    background: black;
    overflow: hidden;
  }

  .top {
    width: 100%;
    background: black;
    padding: 30px 0;

    .column {
      width: 17%;

      a {
        color: white;
        width: 100%;
        display: inline-block;
        text-align: left;
        text-transform: uppercase;
        line-height: 24px;
      }

      a.title {
        font-weight: 700;
        margin-bottom: 6px;
      }

      .children-column+.children-column {
        margin-top: 20px;
      }

      .children-column img {
        text-align: left;
        display: flex;
        max-width: 220px;
        padding-top: 20px;
      }
    }

    .subvenciones {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      border-top: 1px solid white;
      margin-top: 20px;
      
      article {
        margin-top: 20px;
        margin-right: 30px;
      }
    }
  }

  .column .logo, .autocontrol {
    width: 15% !important;
    img {
      max-width: 180px;
    }
  }
  .bottom {
    background: $greyish-brown;
    padding: 20px 0;

    p {
      font-size: 14px;
      color: white;
    }
  }

  .top .column .rrss {
    position: static;
    margin-top: 50px;

    h3,
    a {
      transform: translate(0);
    }

    a {
      width: 25px;
      text-align: center;
    }
  }

  @media screen and (max-width: 1150px) { 
    .top .column:last-of-type {
      width: 100%;
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 790px) {

    .column .logo, .autocontrol {
      width: 100% !important;
    }
    .top .column:first-of-type {
      width: 100%;
      order: 2;
    }

    .top .column:first-of-type .img-logo {
      display: none;
    }

    .top .column .rrss {
      margin-top: 20px;
    }

    .top .column {
      width: 33.333333%;

      a {
        text-align: left;
      }
    }

    .top .column .rrss {
      a {
        width: 50px;
        height: 50px;
        margin-right: 10px;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        justify-content: center;
        -webkit-justify-content: center;
        -ms-align-items: center;
        align-items: center;

        i {
          font-size: 30px;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .top .column {
      width: 50%;
      margin-bottom: 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/footer.vue